if (!customElements.get("delivery-availability")) {
  class DeliveryAvailability extends HTMLElement {

    connectedCallback() {
      this._input_outer = this.querySelector(".delivery__availability__header_mn");
      this._input   = this.querySelector(".postal_code_checker");
      this._success = this.querySelector(".forpostal__success");
      this._error   = this.querySelector(".forpostal__error");
      this._msgs    = this.querySelectorAll(".postalcode__enterance_msg");
      this._zipEl   = this.querySelector(".postalcode__resultZip");
      this._dateEl  = this.querySelector(".postalcode__enterance_msg_msg");
      this._iconBtn = this.querySelector(".topic_search_recipes_icon");

      if (!this._input) return;
      this._bindEvents();
    }

    disconnectedCallback() {
      this._input?.removeEventListener("input",   this._onInput);
      this._input?.removeEventListener("keydown", this._onKeydown);
      this._iconBtn?.removeEventListener("click", this._onSubmit);
    }

    _bindEvents() {
      this._onInput   = (e) => this._handleInput(e);
      this._onKeydown = (e) => { if (e.key === "Enter") this._handleSubmit(); };
      this._onSubmit  = ()  => this._handleSubmit();

      this._input.addEventListener("input",   this._onInput);
      this._input.addEventListener("keydown", this._onKeydown);
      this._iconBtn?.addEventListener("click", this._onSubmit);
    }

    _handleInput(e) {
      this._hideMessages();

      const patterns = ["letter", "digit", "letter", "digit", "letter", "digit"];
      let value = e.target.value.toUpperCase().replace(/\s+/g, "").slice(0, 6);
      let result = "";

      for (let i = 0; i < value.length; i++) {
        const c = value[i];
        if (patterns[i] === "letter" && /[A-Z]/.test(c)) result += c;
        else if (patterns[i] === "digit" && /[0-9]/.test(c)) result += c;
        else break;
      }

      e.target.value = result;
    }

    _handleSubmit() {
      const postalCode = this._input.value.toUpperCase().trim();
      if (!postalCode || postalCode.length < 6) return;

      this._hideMessages();

      const fsa  = postalCode.slice(0, 3);            // e.g. "L9S"
      const zone = DeliveryAvailability._ZONE_MAP[fsa];

      if (zone) {
        const formattedZip  = postalCode.replace(/^(.{3})(.*)$/, "$1 $2");
        const deliveryInfo  = zone.message ?? this._getDeliveryDate(zone.day);
        this._renderSuccess(postalCode, deliveryInfo);
      } else {
        this._renderError();
      }
    }

    _renderSuccess(postalCode, deliveryInfo) {
      const formattedZip = postalCode.replace(/^(.{3})(.*)$/, "$1 $2");

      this._zipEl.textContent  = formattedZip;
      this._dateEl.textContent = deliveryInfo;
      this._success.classList.remove("hidden");
      this._input_outer.classList.add("hidden");

      this.dispatchEvent(new CustomEvent("delivery:available", {
        bubbles: true,
        detail: { zip: formattedZip, date: deliveryInfo }
      }));
    }

    _renderError() {
      this._error.classList.remove("hidden");
      this._input_outer.classList.add("hidden");
      this.dispatchEvent(new CustomEvent("delivery:unavailable", {
        bubbles: true,
        detail: { zip: this._input.value }
      }));
    }

    _getDeliveryDate(deliveryDay) {
      const daysMap = {
        Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3,
        Thursday: 4, Friday: 5, Saturday: 6
      };

      const now  = new Date();
      let diff   = daysMap[deliveryDay] - now.getDay();
      if (diff <= 0) diff += 7;

      const date    = new Date(now);
      date.setDate(now.getDate() + diff);

      const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
      const dayNum  = date.getDate();
      const month   = date.toLocaleDateString("en-US", { month: "short" });
      const year    = date.getFullYear();

      const suffix =
        dayNum % 10 === 1 && dayNum !== 11 ? "st" :
        dayNum % 10 === 2 && dayNum !== 12 ? "nd" :
        dayNum % 10 === 3 && dayNum !== 13 ? "rd" : "th";

      return `${dayName}, ${dayNum}${suffix} ${month}, ${year}`;
    }

    _hideMessages() {
      this._msgs.forEach((el) => el.classList.add("hidden"));
    }

    _setLoading(state) {
      this._iconBtn?.classList.toggle("loading", state);
      if (this._input) this._input.disabled = state;
    }
  }

  const _zones = [
    {
      day: "Wednesday",
      message: "Woohoo! We deliver in your area. Delivery fee is a flat rate $3.99 and we service your area on Wednesday between 11:00 - 20:00",
      codes: [
        "L1C","L1E","L1G","L1H","L1J","L1K","L1L","L1M","L1N","L1P",
        "L1R","L1S","L1T","L1V","L1W","L1X","L1Z","LJ0",
        "K9A","K9H","K9J","K9K","K9L",
        "M1B","M1C","M1E","M1G","M1H","M1J","M1K","M1L","M1M","M1N",
        "M1P","M1R","M1S","M1T","M1V","M1W","M1X",
        "M2H","M2J","M2K","M2L","M2M","M2N","M2P","M2R",
        "M3A","M3B","M3C","M3H","M3J","M3K","M3L","M3M","M3N",
        "M4A","M4B","M4C","M4E","M4G","M4H","M4J","M4K","M4L","M4M",
        "M4N","M4P","M4R","M4S","M4T","M4V","M4W","M4X","M4Y",
        "M5A","M5B","M5C","M5E","M5G","M5H","M5J","M5K","M5L","M5M",
        "M5N","M5P","M5R","M5S","M5T","M5V","M5W","M5X",
        "M6A","M6B","M6C","M6E","M6G","M6H","M6J","M6K","M6L","M6M",
        "M6N","M6P","M6R","M6S","M7A","M7Y"
      ]
    },
    {
      day: "Thursday",
      message : "Woohoo! We deliver in your area. Delivery fee is a flat rate $3.99 and we service your area on Thursday between 11:00 - 20:00",
      codes: [
        "L0G","L0J","L0L","L0M","L0P",
        "L3P","L3R","L3S","L3T","L3W","L3X","L3Y","L3Z",
        "L4A","L4B","L4C","L4E","L4G","L4H","L4J","L4K","L4L","L4M","L4N","L4S",
        "L4T","L4V","L4W","L4X","L4Y","L4Z",
        "L5A","L5B","L5C","L5E","L5G","L5H","L5J","L5K","L5L","L5M",
        "L5N","L5P","L5R","L5S","L5T","L5V","L5W",
        "L6A","L6B","L6C","L6E","L6G","L6H","L6J","L6K","L6L","L6M",
        "L6P","L6R","L6S","L6T","L6V","L6W","L6X","L6Y","L6Z",
        "L7A","L7B","L7C","L7E","L7G","L7J","L7K","L7L","L7M","L7N","L7P","L7R","L7S","L7T",
        "L9E","L9G","L9H","L9J","L9N","L9R","L9S","L9T","L9V","L9W",
        "M8V","M8W","M8X","M8Y","M8Z",
        "M9A","M9B","M9C","M9L","M9M","M9N","M9P","M9R","M9V","M9W",
        "N0E","N0J","N0L","N0M",
        "N4B","N4G","N4S","N4T","N4V","N4X","N4Z",
        "N5A","N5C","N5H","N5L","N5P","N5R",
        "N6N","N7G"
      ]
    },
    {
      day: "Friday",
      message : "Woohoo! We deliver in your area. Delivery fee is a flat rate $3.99 and we service your area on Friday between 10:00 - 20:00",
      codes: [
        "L0R","L0S",
        "L2A","L2E","L2G","L2H","L2J","L2M","L2N","L2P","L2R","L2S","L2T","L2V","L2W",
        "L3B","L3C","L3J","L3K","L3M",
        "L8B","L8E","L8G","L8H","L8J","L8K","L8L","L8M","L8N","L8P","L8R","L8S","L8T","L8V","L8W",
        "L9A","L9B","L9C","L9K",
        "N0A","N0N","N1A",
        "N3L","N3P","N3R","N3S","N3T","N3V","N3W","N3Y",
        "N5Z","N6A","N6E","N6G","N6H","N6K","N6L","N6M","N6P",
        "N7S","N7T","N7V","N7W","N7X","N9Y"
      ]
    },  
    {
      day: "Saturday",
      message : "Woohoo! We deliver in your area. Delivery fee is a flat rate $3.99 and we service your area on Saturday between 11:00 - 18:00",
      codes: [
        "N0B","N0G","N0K",
        "N1C","N1E","N1G","N1H","N1K","N1L","N1M","N1P","N1R","N1S","N1T",
        "N2A","N2B","N2C","N2E","N2G","N2H","N2J","N2K","N2L","N2M","N2N","N2P","N2R","N2T","N2V",
        "N3A","N3B","N3C","N3E","N3H","N4W",
        "N5A","N5V","N5W","N5X","N5Y","N6B","N6C","N6J"
      ]
    },       
    {
      day: "Friday - Windsor",
      message: "Woohoo! We deliver in your area. Delivery fee is a flat rate $3.99 and we service your area on Friday between 11:00 - 18:00",
      codes: [
        "N0R","N8M","N8N","N8P","N8R","N8S","N8T","N8V","N8W","N8X","N8Y",
        "N9A","N9B","N9C","N9E","N9G","N9H","N9J","N9K","N9V"
      ]
    },    
    {
      day: "Saturday - QC",
      message: "Woohoo! We deliver in your area. Delivery fee is a flat rate $3.99 and we service your area on Saturday between 11:00 - 20:00",
      codes: [
        "H1A","H1B","H1C","H1E","H1G","H1H","H1K","H1L","H1M","H1N","H1S","H1T","H1V","H1W","H1X","H1Y","H1Z",
        "H2A","H2B","H2C","H2E","H2G","H2H","H2J","H2K","H2L","H2M","H2N","H2P","H2R","H2S","H2T","H2V","H2W","H2X","H2Y","H2Z",
        "H3A","H3B","H3C","H3E","H3G","H3H","H3J","H3K","H3L","H3M","H3N","H3P","H3R","H3S","H3T","H3V","H3W","H3X","H3Y","H3Z",
        "H4A","H4B","H4C","H4E","H4G","H4H","H4J","H4K","H4L","H4M","H4N","H4P","H4R","H4S","H4T","H4V","H4W","H4X","H4Y","H4Z",
        "H5A","H5B",
        "H7A","H7B","H7C","H7E","H7G","H7H","H7J","H7K","H7L","H7M","H7N","H7P","H7R","H7S","H7T","H7V","H7W","H7X","H7Y",
        "H8N","H8P","H8R","H8S","H8T","H8Y","H8Z",
        "H9A","H9B","H9C","H9E","H9G","H9H","H9J","H9K","H9P","H9R","H9S","H9W","H9X",
        "J0P",
        "J2R","J2S","J2T","J2W","J2X","J2Y",
        "J3B","J3E","J3G","J3H","J3L","J3M","J3N","J3V","J3X","J3Y",
        "J4B","J4G","J4H","J4J","J4K","J4L","J4M","J4N","J4Y",
        "J5A","J5B","J5C","J5R","J5Y",
        "J6A","J6J","J6K","J6N","J6R","J6S","J6T","J6V","J6W","J6X","J6Y","J6Z",
        "J7A","J7B","J7C","J7E","J7G","J7H","J7J","J7K","J7L","J7M","J7N","J7P","J7R","J7T","J7V","J7W","J7Y","J7Z"
      ]
    },     
    {
      day: "Saturday - Ottawa",
      message: "Woohoo! We deliver in your area. Delivery fee is a flat rate $3.99 and we service your area on Saturday between 08:00 - 18:00",
      codes: [
        "J8P","J8R","J8T","J8V","J8X","J8Y","J8Z",
        "J9A","J9B","J9H","J9J","J9L","J9P","J9X","J9Z",
        "K0A","K0B","K0C","K0E","K0G","K0J","K0L","K0M",
        "K1B","K1C","K1E","K1G","K1H","K1J","K1K","K1L","K1M","K1N","K1P","K1R","K1S","K1T","K1V","K1W","K1X","K1Y","K1Z",
        "K2A","K2B","K2C","K2E","K2G","K2H","K2J","K2K","K2L","K2M","K2P","K2S","K2T","K2V","K2W",
        "K4A","K4B","K4K","K4M","K4P","K4R",
        "K6H","K6J","K6K","K6V","K7C"
      ]
    },     
    {
      day: "British Columbia",
      message: "Woohoo! We deliver in your area. Delivery fee is a flat rate $5.99 and we service your area on Thursday between 11:00 - 20:00",
      codes: [
        "V1M",
        "V2P","V2R","V2S","V2T","V2V","V2W","V2X","V2Y","V2Z",
        "V3A","V3B","V3C","V3E","V3G","V3H","V3J","V3K","V3L","V3M","V3N","V3R","V3S","V3T","V3V","V3W","V3X","V3Y","V3Z",
        "V4A","V4B","V4C","V4E","V4G","V4K","V4L","V4M","V4N","V4P","V4R","V4S","V4W","V4X","V4Z",
        "V5A","V5B","V5C","V5E","V5G","V5H","V5J","V5K","V5L","V5M","V5N","V5P","V5R","V5S","V5T","V5V","V5W","V5X","V5Y","V5Z",
        "V6A","V6B","V6C","V6E","V6G","V6H","V6J","V6K","V6L","V6M","V6N","V6P","V6R","V6S","V6T","V6V","V6W","V6X","V6Y","V6Z",
        "V7A","V7B","V7C","V7E","V7G","V7H","V7J","V7K","V7L","V7M","V7N","V7P","V7R","V7S","V7T","V7V","V7W","V7X","V7Y"
      ]
    },    
    {
      day: "Saturday - Kingston",
      message: "Woohoo! We deliver in your area. Delivery fee is a flat rate $3.99 and we service your area on Saturday between 06:00 - 18:00",
      codes: ["K0H","K0K","K7A","K7K","K7L","K7M","K7N","K7P"]
    },
    {
      day: "Friday - Calgary",
      message: "Woohoo! We deliver in your area. Delivery fee is a flat rate $5.99 and we service your area on Friday between 10:00 - 19:00",
      codes: [
        "T0J","T0L",
        "T1P","T1R","T1S","T1V","T1X","T1Y","T1Z",
        "T2A","T2B","T2C","T2E","T2G","T2H","T2J","T2K","T2L","T2M","T2N","T2P","T2R","T2S","T2T","T2V","T2W","T2X","T2Y","T2Z",
        "T3A","T3B","T3C","T3E","T3G","T3H","T3J","T3K","T3L","T3M","T3N","T3P","T3R","T3S","T3T","T3Z",
        "T4A","T4B","T4C"
      ]
    }
  ];
  DeliveryAvailability._ZONE_MAP = Object.create(null);
  for (const zone of _zones) {
    for (const code of zone.codes) {
      DeliveryAvailability._ZONE_MAP[code] = zone;
    }
  }
  customElements.define("delivery-availability", DeliveryAvailability);
}